import React from 'react';
import { AppButton } from '@/components/atoms';
import BottomBar from '@/components/organisms/Footer';
import { useSidebarOpen } from '@shared/providers/SidebarContext';
import { useTheme } from '@shared/providers/theme/ThemeContext';

interface PatientCheckinMailFormBottomBarProps {
  mode: 'create' | 'edit';
  isSubmitting: boolean;
  formId: string;
  onBack: () => void;
  onDelete?: () => void;
  isDeleting?: boolean;
}

const PatientCheckinMailFormBottomBar: React.FC<PatientCheckinMailFormBottomBarProps> = ({
  mode,
  isSubmitting,
  formId,
  onBack,
  onDelete,
  isDeleting = false,
}) => {
  const sidebarOpen = useSidebarOpen();
  const { colors } = useTheme();
  const isBusy = isSubmitting || isDeleting;

  const right = (
    <div className="flex gap-4">
      <AppButton
        type="default"
        onClick={onBack}
        disabled={isBusy}
        className="px-4 py-2 font-medium rounded"
      >
        戻る
      </AppButton>
      {mode === 'edit' && onDelete && (
        <AppButton
          danger
          type="primary"
          onClick={onDelete}
          disabled={isBusy}
          loading={isDeleting}
          className="px-4 py-2 font-medium text-white rounded"
        >
          削除
        </AppButton>
      )}
      <AppButton
        type="primary"
        htmlType="submit"
        form={formId}
        loading={isSubmitting}
        disabled={isBusy}
        className="px-12 py-2 font-medium text-white rounded"
        style={{ backgroundColor: colors.secondary, borderColor: colors.secondary }}
      >
        <i className="mr-2 fa fa-paper-plane" aria-hidden="true" /> 更新
      </AppButton>
    </div>
  );

  return (
    <BottomBar
      variant="action"
      visible={true}
      right={right}
      fixed
      className={sidebarOpen ? 'left-60' : 'left-0'}
    />
  );
};

export default PatientCheckinMailFormBottomBar;
